import React, {useMemo} from 'react';
import {FmlxIcon, FmlxTooltip} from 'fmlx-common-ui';

import {useSelector} from 'react-redux';
import {selectInstrumentStatus} from 'stores/selectors/instrumentSelectors';
import {useIntl} from 'react-intl';
import {InstrumentStatusType} from 'constants/dataEnum';
import {selectUserExecutorName} from 'stores/selectors/runtimeSelector';
import {selectRunningProtocolName} from 'stores/selectors/protocolExplorerSelectors';
import style from './InstrumentStatus.module.scss';

function InstrumentStatus() {
  const {formatMessage} = useIntl();
  const instrumentStatus = useSelector(selectInstrumentStatus);
  const executorName = useSelector(selectUserExecutorName);
  const runningProtocolName = useSelector(selectRunningProtocolName);

  const getTitle = useMemo(() => {
    let messageId = 'statusBar.instrumentOperational.tooltip';
    let value;

    switch (instrumentStatus) {
      case InstrumentStatusType.NON_OPERATIONAL: {
        messageId = 'statusBar.instrumentNonOperational.tooltip';
        break;
      }
      case InstrumentStatusType.RUNNING: {
        messageId = 'statusBar.instrumentRunning.tooltip';
        break;
      }
      case InstrumentStatusType.PAUSED: {
        messageId = 'statusBar.instrumentPaused.tooltip';
        break;
      }
      case InstrumentStatusType.NEED_USER_ATTENTION: {
        messageId = 'statusBar.instrumentNeedUserAttention.tooltip';
        value = {username: executorName || runningProtocolName || 'User'};
        break;
      }
      default:
        break;
    }

    return formatMessage({id: messageId}, value);
  }, [formatMessage, instrumentStatus, executorName, runningProtocolName]);

  const getIcon = useMemo(() => {
    let name = 'CheckboxDefault';
    let color = '#4CAF50';

    switch (instrumentStatus) {
      case InstrumentStatusType.NON_OPERATIONAL: {
        name = 'Cancel';
        color = '#FF5252';
        break;
      }
      case InstrumentStatusType.RUNNING: {
        name = 'PlayCircle';
        break;
      }
      case InstrumentStatusType.PAUSED: {
        name = 'Pause';
        color = '#FFCA0A';
        break;
      }
      case InstrumentStatusType.NEED_USER_ATTENTION: {
        name = 'Warning';
        color = '#FFCA0A';
        break;
      }
      default:
        break;
    }

    return {name, color};
  }, [instrumentStatus]);

  return (
    <div className={style.container}>
      <FmlxTooltip title={getTitle} placement={FmlxTooltip.Placement.TOP}>
        <div className={style.icon}>
          <FmlxIcon size={24} name={getIcon.name} customColor={getIcon.color} />
        </div>
      </FmlxTooltip>
    </div>
  );
}

export default InstrumentStatus;
